import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InputNumberModule } from 'primeng/inputnumber';
import { CustomerImageModule } from '../../../customer/image/customer-image.module';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { FinanceSharedModule } from '../../finance-shared.module';
import { DisbursementService } from '../../services/disbursement.service';
import { DisbursementSummaryModal } from './disbursement-summary-modal.component';
import { DisbursementSummaryComponent } from './disbursement-summary.component';
import { DisbursementSummaryRoutes } from './disbursement-summary.routes';

@NgModule({
    declarations: [
        DisbursementSummaryComponent,
        DisbursementSummaryModal
    ],
    providers: [
        DisbursementService
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(DisbursementSummaryRoutes),
        FinanceSharedModule,
        CustomerImageModule,
        FormsModule,
        InputNumberModule,
        ValidationResultsModule
    ],
    exports: [
        DisbursementSummaryComponent
    ]
})
export class DisbursementSummaryModule {
}
